import { Button, FlexContainer } from '@act/storybook';

interface EditUserActionsProps {
  isEditing: boolean;
  saveDisabled: boolean;
  isPadded?: boolean;
  handleSave: () => void;
  handleDeleteUser: () => void;
}

export const EditUserActions = ({
  isEditing,
  saveDisabled,
  isPadded = false,
  handleSave,
  handleDeleteUser,
}: EditUserActionsProps) => {
  return (
    <FlexContainer
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      height="max-content"
      width="100%"
      gap={1}
      padding={isPadded ? '8px 16px 16px 0' : '0'}
      flexShrink={1}
      overflow="visible"
      overflowX="visible"
      overflowY="visible"
    >
      <Button
        type="button"
        debounced
        onClick={handleSave}
        disabled={saveDisabled}
        sx={{
          padding: '12px 16px',
          marginRight: '16px',
          minWidth: '100px',
        }}
      >
        Save User
      </Button>
      {isEditing && (
        <Button
          variant="outlined"
          type="button"
          debounced
          onClick={handleDeleteUser}
          sx={{ padding: '12px 16px', color: 'red', borderColor: 'red' }}
        >
          Delete User
        </Button>
      )}
    </FlexContainer>
  );
};
